(function() {
  var stringUtil;

  stringUtil = require('resources/assets/coffee/Core/utils/string');

  exports.Repository = (function() {
    function Repository(store) {
      if (store == null) {
        store = {};
      }
      this.store = store;
    }

    Repository.prototype.get = function(key, def) {
      var val;
      if (def == null) {
        def = null;
      }
      if (key === '') {
        return this.store;
      }
      val = this._tryFind(key);
      if (val == null) {
        return def;
      }
      return val;
    };

    Repository.prototype.set = function(key, value) {
      return stringUtil.setElementIn(key, value, this.store);
    };

    Repository.prototype.has = function(key) {
      if (this._tryFind(key) != null) {
        return true;
      }
      return false;
    };

    Repository.prototype._tryFind = function(key) {
      var error;
      try {
        return stringUtil.toElementIn(key, this.store);
      } catch (error1) {
        error = error1;
        return null;
      }
    };

    return Repository;

  })();

}).call(this);
